import {SpriteConfig} from "@/entities/game/types";

export const getRandomFromRange = (min:number, max:number) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const getRandomNumber = (
        offsetSquare:number,
        spriteSquare:SpriteConfig,
        spritePlayer:SpriteConfig,
        spriteGate:SpriteConfig
) => {
    const left = spriteSquare.x + offsetSquare/2 + (spritePlayer.width/2);
    const randomNumberFrom = getRandomFromRange(left, spriteGate.x );
    const randomNumberTo = getRandomFromRange(spriteGate.x, spriteSquare.width - offsetSquare/2 - (spritePlayer.width/2));
    return Math.random() < 0.5 ? randomNumberFrom : randomNumberTo;
}
